import TableBilling from "../TableBilling";

export const TableItems = (
  filteredDataCount,
  billing,
  filteredData,
  paginatedData,
  tabKey,
  setFilteredData,
  selectedRow,
  setSelectedRow,
  user,
  selectedRowKeys,
  setSelectedRowKeys,
) => {
  const isUserAdmin = user.uroleid === "A";

  const tabs = [
    {
      label: `All (${filteredDataCount["all"]})`,
      key: "all",
      children: (
        <TableBilling
          source={billing}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      ),
    },
    {
      label: `Unpaid (${filteredDataCount[2]})`,
      key: 2,
      children: (
        <TableBilling
          source={billing}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      ),
    },
    {
      label: `Pending Verify (${filteredDataCount[3]})`,
      key: 3,
      children: (
        <TableBilling
          source={billing}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      ),
    },
    {
      label: `Paid (${filteredDataCount[4]})`,
      key: 4,
      children: (
        <TableBilling
          source={billing}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      ),
    },
  ];

  if (isUserAdmin) {
    tabs.splice(1, 0, {
      label: `Draft (${filteredDataCount[1] || 0})`,
      key: 1,
      children: (
        <TableBilling
          source={billing}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      ),
    });
  }
  return tabs;
};
